import React from 'react';
import { Button, Form, Space, Typography } from 'antd';
import { InputField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const { Title } = Typography;

export default (props) => {
  const { searchVal } = props;
  const { control, handleSubmit } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  const onSubmit = (val) => {
    props.onSearch(val);
  };

  return (
    <Space size={15} direction="vertical" className="w-100">
      <Title level={5} className="c-gray mb-0">
        {t("System.filter_list")}:
      </Title>
      <Form onFinish={handleSubmit(onSubmit)} layout="inline" className="w-100 inline-form">
        <InputField
          fieldname="user_role"
          class="mb-0 w-100"
          label=""
          control={control}
          iProps={{ placeholder: t("General.type_user_role_name") }}
          initValue={searchVal?.user_role ? searchVal?.user_role : ''}
        />
        <Button size="large" type="primary" htmlType="submit">
          {t("General.search")}
        </Button>
      </Form>
    </Space>
  );
};
